"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_LOGIN_LINK_KEY = exports.fetchGetGeneralDocumentDownload = exports.GET_GENERAL_DOCUMENT_DOWNLOAD_KEY = exports.fetchGetFundingRequirement = exports.GET_FUNDING_REQUIREMENT_KEY = exports.fetchGetEmailAvailability = exports.GET_EMAIL_AVAILABILITY_KEY = exports.fetchPutDocumentUpload = exports.PUT_DOCUMENT_UPLOAD_KEY = exports.fetchPostDocumentUpload = exports.POST_DOCUMENT_UPLOAD_KEY = exports.fetchGetDocumentUpload = exports.GET_DOCUMENT_UPLOAD_KEY = exports.fetchGetCreditFacilityStatus = exports.GET_CREDIT_FACILITY_STATUS_KEY = exports.fetchGetCreditFacilityRepaymentSchedule = exports.GET_CREDIT_FACILITY_REPAYMENT_SCHEDULE_KEY = exports.fetchPostCreditFacilityPaymentRequest = exports.POST_CREDIT_FACILITY_PAYMENT_REQUEST_KEY = exports.fetchPostCreditFacilityPaymentRequestByPaymentMethodId = exports.POST_CREDIT_FACILITY_PAYMENT_REQUEST_BY_PAYMENT_METHOD_ID_KEY = exports.fetchPostCreditFacilityFundingRequest = exports.POST_CREDIT_FACILITY_FUNDING_REQUEST_KEY = exports.fetchGetCreditFacilityFeatures = exports.GET_CREDIT_FACILITY_FEATURES_KEY = exports.fetchGetCreditFacilityCustomerDocumentDownload = exports.GET_CREDIT_FACILITY_CUSTOMER_DOCUMENT_DOWNLOAD_KEY = exports.fetchPutCreditFacilityCustomerDocument = exports.PUT_CREDIT_FACILITY_CUSTOMER_DOCUMENT_KEY = exports.fetchGetCreditFacilityCustomerDocument = exports.GET_CREDIT_FACILITY_CUSTOMER_DOCUMENT_KEY = exports.fetchGetContext = exports.GET_CONTEXT_KEY = exports.fetchGetContextByStateKey = exports.GET_CONTEXT_BY_STATE_KEY_KEY = exports.fetchGetCompanySearch = exports.GET_COMPANY_SEARCH_KEY = exports.fetchPostChallengeResponse = exports.POST_CHALLENGE_RESPONSE_KEY = exports.fetchGetChallengeResponse = exports.GET_CHALLENGE_RESPONSE_KEY = exports.fetchGetAssociatedPeople = exports.GET_ASSOCIATED_PEOPLE_KEY = exports.fetchPostApprovalRequest = exports.POST_APPROVAL_REQUEST_KEY = exports.fetchGetAccountStatement = exports.GET_ACCOUNT_STATEMENT_KEY = exports.LapiError = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
exports.fetchPutState = exports.PUT_STATE_KEY = exports.fetchGetState = exports.GET_STATE_KEY = exports.fetchGetStateByStateKey = exports.GET_STATE_BY_STATE_KEY_KEY = exports.fetchPostState = exports.POST_STATE_KEY = exports.fetchGetReport = exports.GET_REPORT_KEY = exports.fetchPostRepaymentPaymentMethod = exports.POST_REPAYMENT_PAYMENT_METHOD_KEY = exports.fetchGetRepaymentPaymentMethod = exports.GET_REPAYMENT_PAYMENT_METHOD_KEY = exports.fetchPostRepaymentPaymentIntent = exports.POST_REPAYMENT_PAYMENT_INTENT_KEY = exports.fetchGetRepaymentPaymentIntent = exports.GET_REPAYMENT_PAYMENT_INTENT_KEY = exports.fetchGetPostcodeLookup = exports.GET_POSTCODE_LOOKUP_KEY = exports.fetchPutPaymentMethod = exports.PUT_PAYMENT_METHOD_KEY = exports.fetchPostPaymentMethod = exports.POST_PAYMENT_METHOD_KEY = exports.fetchGetPaymentMethod = exports.GET_PAYMENT_METHOD_KEY = exports.fetchPostPaymentConfirmation = exports.POST_PAYMENT_CONFIRMATION_KEY = exports.fetchGetPaymentConfirmation = exports.GET_PAYMENT_CONFIRMATION_KEY = exports.fetchPostPasswordReset = exports.POST_PASSWORD_RESET_KEY = exports.fetchPostPasswordChange = exports.POST_PASSWORD_CHANGE_KEY = exports.fetchGetLoginLink = void 0;
const lendingAPI_1 = require("./lendingAPI");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
Object.defineProperty(exports, "LapiError", { enumerable: true, get: function () { return lendingAPI_2.LapiError; } });
exports.GET_ACCOUNT_STATEMENT_KEY = "getAccountStatement";
/**
 * No description
 */
function fetchGetAccountStatement({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/account_statement/${stateKey}/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetAccountStatement = fetchGetAccountStatement;
exports.POST_APPROVAL_REQUEST_KEY = "postApprovalRequest";
/**
 * This method should be used when a decision needs to be made for a customer. It doesn&#x27;t expect any payload, all needed information should have been provided in the state of the customer.
 */
function fetchPostApprovalRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/approval_request/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostApprovalRequest = fetchPostApprovalRequest;
exports.GET_ASSOCIATED_PEOPLE_KEY = "getAssociatedPeople";
/**
 * Retrieve the people associated with the company on the application.
 */
function fetchGetAssociatedPeople({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/associated_people/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetAssociatedPeople = fetchGetAssociatedPeople;
exports.GET_CHALLENGE_RESPONSE_KEY = "getChallengeResponse";
/**
 * No description
 */
function fetchGetChallengeResponse({ stateKey, personUid, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/challenge_response/${stateKey}/${personUid}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetChallengeResponse = fetchGetChallengeResponse;
exports.POST_CHALLENGE_RESPONSE_KEY = "postChallengeResponse";
/**
 * No description
 */
function fetchPostChallengeResponse({ stateKey, personUid, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/challenge_response/${stateKey}/${personUid}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostChallengeResponse = fetchPostChallengeResponse;
exports.GET_COMPANY_SEARCH_KEY = "getCompanySearch";
/**
 * No description
 */
function fetchGetCompanySearch({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/company_search/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetCompanySearch = fetchGetCompanySearch;
exports.GET_CONTEXT_BY_STATE_KEY_KEY = "getContextByStateKey";
/**
 * Collection of attributes to operate with iwoca&#x27;s lending API.
 */
function fetchGetContextByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/context/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetContextByStateKey = fetchGetContextByStateKey;
exports.GET_CONTEXT_KEY = "getContext";
/**
 * Collection of attributes to operate with iwoca&#x27;s lending API.
 */
function fetchGetContext({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/context/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetContext = fetchGetContext;
exports.GET_CREDIT_FACILITY_CUSTOMER_DOCUMENT_KEY = "getCreditFacilityCustomerDocument";
/**
 * No description
 */
function fetchGetCreditFacilityCustomerDocument({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_customer_document/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetCreditFacilityCustomerDocument = fetchGetCreditFacilityCustomerDocument;
exports.PUT_CREDIT_FACILITY_CUSTOMER_DOCUMENT_KEY = "putCreditFacilityCustomerDocument";
/**
 * No description
 */
function fetchPutCreditFacilityCustomerDocument({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/credit_facility_customer_document/${stateKey}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutCreditFacilityCustomerDocument = fetchPutCreditFacilityCustomerDocument;
exports.GET_CREDIT_FACILITY_CUSTOMER_DOCUMENT_DOWNLOAD_KEY = "getCreditFacilityCustomerDocumentDownload";
/**
 * No description
 */
function fetchGetCreditFacilityCustomerDocumentDownload({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/credit_facility_customer_document/${stateKey}/${documentId}/download/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetCreditFacilityCustomerDocumentDownload = fetchGetCreditFacilityCustomerDocumentDownload;
exports.GET_CREDIT_FACILITY_FEATURES_KEY = "getCreditFacilityFeatures";
/**
 * The data returned contains general information about credit, ...
 */
function fetchGetCreditFacilityFeatures({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_features/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetCreditFacilityFeatures = fetchGetCreditFacilityFeatures;
exports.POST_CREDIT_FACILITY_FUNDING_REQUEST_KEY = "postCreditFacilityFundingRequest";
/**
 * No description
 */
function fetchPostCreditFacilityFundingRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/credit_facility_funding_request/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostCreditFacilityFundingRequest = fetchPostCreditFacilityFundingRequest;
exports.POST_CREDIT_FACILITY_PAYMENT_REQUEST_BY_PAYMENT_METHOD_ID_KEY = "postCreditFacilityPaymentRequestByPaymentMethodId";
/**
 * No description
 */
function fetchPostCreditFacilityPaymentRequestByPaymentMethodId({ stateKey, paymentMethodId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_payment_request/${stateKey}/${paymentMethodId}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostCreditFacilityPaymentRequestByPaymentMethodId = fetchPostCreditFacilityPaymentRequestByPaymentMethodId;
exports.POST_CREDIT_FACILITY_PAYMENT_REQUEST_KEY = "postCreditFacilityPaymentRequest";
/**
 * No description
 */
function fetchPostCreditFacilityPaymentRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_payment_request/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostCreditFacilityPaymentRequest = fetchPostCreditFacilityPaymentRequest;
exports.GET_CREDIT_FACILITY_REPAYMENT_SCHEDULE_KEY = "getCreditFacilityRepaymentSchedule";
/**
 * Returning the repayment schedule for a customer, with possible early repayment or new draw-down simulation.
 */
function fetchGetCreditFacilityRepaymentSchedule({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_repayment_schedule/${stateKey}/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetCreditFacilityRepaymentSchedule = fetchGetCreditFacilityRepaymentSchedule;
exports.GET_CREDIT_FACILITY_STATUS_KEY = "getCreditFacilityStatus";
/**
 * The data returned contains information like approval status, loan status, repayments, cashflows, ...
 */
function fetchGetCreditFacilityStatus({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_status/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetCreditFacilityStatus = fetchGetCreditFacilityStatus;
exports.GET_DOCUMENT_UPLOAD_KEY = "getDocumentUpload";
/**
 * No description
 */
function fetchGetDocumentUpload({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/document_upload/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetDocumentUpload = fetchGetDocumentUpload;
exports.POST_DOCUMENT_UPLOAD_KEY = "postDocumentUpload";
/**
 * No description
 */
function fetchPostDocumentUpload({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/document_upload/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostDocumentUpload = fetchPostDocumentUpload;
exports.PUT_DOCUMENT_UPLOAD_KEY = "putDocumentUpload";
/**
 * No description
 */
function fetchPutDocumentUpload({ stateKey, documentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/document_upload/${stateKey}/${documentId}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutDocumentUpload = fetchPutDocumentUpload;
exports.GET_EMAIL_AVAILABILITY_KEY = "getEmailAvailability";
/**
 * No description
 */
function fetchGetEmailAvailability({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/email_availability/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetEmailAvailability = fetchGetEmailAvailability;
exports.GET_FUNDING_REQUIREMENT_KEY = "getFundingRequirement";
/**
 * No description
 */
function fetchGetFundingRequirement({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirement/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetFundingRequirement = fetchGetFundingRequirement;
exports.GET_GENERAL_DOCUMENT_DOWNLOAD_KEY = "getGeneralDocumentDownload";
/**
 * No description
 */
function fetchGetGeneralDocumentDownload({ documentType, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/general_document/${documentType}/download/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetGeneralDocumentDownload = fetchGetGeneralDocumentDownload;
exports.GET_LOGIN_LINK_KEY = "getLoginLink";
/**
 * No description
 */
function fetchGetLoginLink({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/login_link/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetLoginLink = fetchGetLoginLink;
exports.POST_PASSWORD_CHANGE_KEY = "postPasswordChange";
/**
 * Change a user&#x27;s password, given their old password.
 */
function fetchPostPasswordChange({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/password_change/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPasswordChange = fetchPostPasswordChange;
exports.POST_PASSWORD_RESET_KEY = "postPasswordReset";
/**
 * Given an email address, a user can request a password reset link
 */
function fetchPostPasswordReset({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/password_reset/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPasswordReset = fetchPostPasswordReset;
exports.GET_PAYMENT_CONFIRMATION_KEY = "getPaymentConfirmation";
/**
 * No description
 */
function fetchGetPaymentConfirmation({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/payment_confirmation/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetPaymentConfirmation = fetchGetPaymentConfirmation;
exports.POST_PAYMENT_CONFIRMATION_KEY = "postPaymentConfirmation";
/**
 * No description
 */
function fetchPostPaymentConfirmation({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/payment_confirmation/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPaymentConfirmation = fetchPostPaymentConfirmation;
exports.GET_PAYMENT_METHOD_KEY = "getPaymentMethod";
/**
 * Retrieve the payment methods linked to the customer.
 */
function fetchGetPaymentMethod({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/payment_method/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetPaymentMethod = fetchGetPaymentMethod;
exports.POST_PAYMENT_METHOD_KEY = "postPaymentMethod";
/**
 * Sending a POST request with a valid body will result in creating a chargeable payment method for the specified customer.
 */
function fetchPostPaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/payment_method/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPaymentMethod = fetchPostPaymentMethod;
exports.PUT_PAYMENT_METHOD_KEY = "putPaymentMethod";
/**
 * No description
 */
function fetchPutPaymentMethod({ stateKey, paymentMethodId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/payment_method/${stateKey}/${paymentMethodId}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutPaymentMethod = fetchPutPaymentMethod;
exports.GET_POSTCODE_LOOKUP_KEY = "getPostcodeLookup";
/**
 * No description
 */
function fetchGetPostcodeLookup({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/postcode_lookup/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetPostcodeLookup = fetchGetPostcodeLookup;
exports.GET_REPAYMENT_PAYMENT_INTENT_KEY = "getRepaymentPaymentIntent";
/**
 * Get payment intents for a given payment method
 */
function fetchGetRepaymentPaymentIntent({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_intent/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetRepaymentPaymentIntent = fetchGetRepaymentPaymentIntent;
exports.POST_REPAYMENT_PAYMENT_INTENT_KEY = "postRepaymentPaymentIntent";
/**
 * Create an intent to pay.
 */
function fetchPostRepaymentPaymentIntent({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_intent/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostRepaymentPaymentIntent = fetchPostRepaymentPaymentIntent;
exports.GET_REPAYMENT_PAYMENT_METHOD_KEY = "getRepaymentPaymentMethod";
/**
 * Get all repayment methods for the given state key
 */
function fetchGetRepaymentPaymentMethod({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_method/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetRepaymentPaymentMethod = fetchGetRepaymentPaymentMethod;
exports.POST_REPAYMENT_PAYMENT_METHOD_KEY = "postRepaymentPaymentMethod";
/**
 * Create an intent to add a card or direct debit mandate.
 */
function fetchPostRepaymentPaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_method/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostRepaymentPaymentMethod = fetchPostRepaymentPaymentMethod;
exports.GET_REPORT_KEY = "getReport";
/**
 * No description
 */
function fetchGetReport({ reportType }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/report/${reportType}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetReport = fetchGetReport;
exports.POST_STATE_KEY = "postState";
/**
 * The POST request should be used to create an iwoca account for the customer. It&#x27;s always the first endpoint and method you should call when submitting a new customer. We&#x27;ll return a state_key used to identify the customer in all future requests. Almost all fields in the State are optional since you can submit a partial application initially, then add or update data over time (through the PUT method). Your iwoca contact will be able to give you details on which fields are recommended to help us make a lending decision.
 */
function fetchPostState({ headers, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/`, {
        method: "post",
        version: "v1",
        overrideHeaders: headers,
        body,
    });
}
exports.fetchPostState = fetchPostState;
exports.GET_STATE_BY_STATE_KEY_KEY = "getStateByStateKey";
/**
 * No description
 */
function fetchGetStateByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetStateByStateKey = fetchGetStateByStateKey;
exports.GET_STATE_KEY = "getState";
/**
 * No description
 */
function fetchGetState({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetState = fetchGetState;
exports.PUT_STATE_KEY = "putState";
/**
 * The PUT request should be used to add or update data for a customer. Note that the entire State should be submitted each time you use this endpoint, even if you are just updating a few fields.
 */
function fetchPutState({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/${stateKey}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutState = fetchPutState;
